var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Upload',{attrs:{"disabled":"","type":"drag","before-upload":_vm.handleUpload,"action":_vm.uploadAction}},[_c('div',{staticStyle:{"padding":"20px 0"}},[_c('Icon',{staticStyle:{"color":"#3399ff"},attrs:{"type":"ios-cloud-upload","size":"52"}}),_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }